<template lang="pug">
    table.playground
        tr(v-for="(elements, rowIndex) in gameItems")
            td.memory-item(
                    v-for="(item, columnIndex) in elements"
                    @click="$emit('selectItem', item, rowIndex, columnIndex)"
                )
                img.game-item.game-item_hidden(:src="item.value | apiFile")
                span.memory-item__number(
                    :class="{'memory-item__number_big': shirtNumbers[rowIndex][columnIndex] > 9}"
                    ) {{ shirtNumbers[rowIndex][columnIndex] }}
</template>

<script>
    export default {
        props: {
            gameItems: Array,
            amountOfColumns: Number,
        },
        mounted() {
            let windowWidth = window.innerWidth;
            let cells = document.querySelectorAll('.memory-item');
            if (cells?.length) {
                if (this.amountOfColumns === 4 && windowWidth >= 768) {
                    this.setStyleForTableCells(cells, 'memory-item_small');
                }
                if (this.amountOfColumns === 5 && windowWidth >= 768) {
                    this.setStyleForTableCells(cells, 'memory-item_x-small');
                }
                if (
                    (this.gameItems.length === 5 && windowWidth >= 768) ||
                    (this.amountOfColumns < 4 && windowWidth <= 576)
                ) {
                    this.setStyleForTableCells(cells, 'memory-item_tiny');
                }
                if (
                    ((this.gameItems.length === 6 || this.amountOfColumns === 6) &&
                        windowWidth < 1440 &&
                        windowWidth > 576) ||
                    (windowWidth < 768 && windowWidth > 576) ||
                    ((this.amountOfColumns === 4 || this.amountOfColumns === 5) && windowWidth <= 576)
                ) {
                    this.setStyleForTableCells(cells, 'memory-item_x-tiny');
                }
                if (this.amountOfColumns === 6 && windowWidth <= 576) {
                    this.setStyleForTableCells(cells, 'memory-item_xs-tiny');
                }
            }
        },
        methods: {
            setStyleForTableCells(cells, styleName) {
                cells.forEach(cell => {
                    cell.classList.add(`${styleName}`);
                });
            },
        },
        computed: {
            shirtNumbers() {
                let numbers = [];
                let counter = 0;
                for (let i = 0; i < this.gameItems.length; i++) {
                    for (let j = 0; j < this.amountOfColumns; j++) {
                        counter += 1;
                        numbers.push([]);
                        numbers[i][j] = counter;
                    }
                }
                return numbers;
            },
        },
    };
</script>

<style scoped lang="scss">
    .playground {
        width: auto;
        border-collapse: separate;
        border-spacing: 5px;
        border-radius: 10px;
        table-layout: fixed;
        background: #ffffff;
        @include media($xlg) {
            border-spacing: 10px;
        }
    }
    .memory-item {
        border: 2px solid #ffffff;
        border-radius: 10px;
        cursor: pointer;
        user-select: none;
        transition: all 0.5s ease;
        transform: rotateY(-180deg);
        background: url('../../../../assets/images/card-background.png') #6bbd6c;
        background-size: cover;
        width: 110px;
        max-width: 200px;
        height: 110px;
        max-height: 200px;
        overflow: hidden;
        @include media($xlg) {
            height: 150px;
            width: 150px;
        }
        img {
            display: block;
            width: 110px;
            max-width: 200px;
            height: 110px;
            max-height: 200px;
            @include media($xlg) {
                height: 150px;
                width: 150px;
            }
        }
        &_disabled {
            pointer-events: none;
        }
        &_selected {
            background-image: none;
            border: 2px solid #6bbd6c;
            transform: rotateY(0);
        }
        &_correct {
            background-image: none;
            pointer-events: none;
            border: 2px solid #6bbd6c;
            transform: rotateY(0);
        }
        &_before-game-started {
            border: none;
        }
        &_small {
            @include media($xlg) {
                height: 150px;
                width: 150px;
            }
            width: 110px;
            height: 110px;
            img {
                @include media($xlg) {
                    height: 150px;
                    width: 150px;
                }
                width: 110px;
                height: 110px;
            }
            .memory-item__number {
                @include media($xlg) {
                    font-size: 62px;
                    line-height: 73px;
                    &_big {
                        left: 35%;
                    }
                }
                font-size: 48px;
                line-height: 60px;
                &_big {
                    left: 30%;
                }
            }
        }
        &_x-small {
            @include media($xlg) {
                width: 150px;
                height: 150px;
            }
            @include media($lg) {
                width: 110px;
                height: 110px;
            }
            width: 105px;
            height: 105px;
            img {
                @include media($xlg) {
                    width: 150px;
                    height: 150px;
                }
                @include media($lg) {
                    width: 110px;
                    height: 110px;
                }
                width: 105px;
                height: 105px;
            }
            .memory-item__number {
                @include media($xlg) {
                    font-size: 62px;
                    line-height: 73px;
                    &_big {
                        left: 35%;
                    }
                }
                @include media($lg) {
                    font-size: 48px;
                    line-height: 60px;
                    &_big {
                        left: 30%;
                    }
                }
                font-size: 46px;
                line-height: 63px;
                &_big {
                    left: 25%;
                }
            }
        }
        &_tiny {
            @include media($xlg) {
                width: 120px;
                height: 120px;
            }
            @include media($lg) {
                width: 90px;
                height: 90px;
            }
            width: 87px;
            height: 87px;
            img {
                @include media($xlg) {
                    width: 120px;
                    height: 120px;
                }
                @include media($lg) {
                    width: 90px;
                    height: 90px;
                }
                width: 87px;
                height: 87px;
            }
            .memory-item__number {
                font-size: 52px;
                line-height: 62px;
                top: 25%;
                @include media($xlg) {
                    font-size: 30px;
                    line-height: 43px;
                    &_big {
                        left: 35%;
                    }
                }
                @include media($lg) {
                    font-size: 40px;
                    line-height: 50px;
                    &_big {
                        left: 30%;
                    }
                }
            }
        }
        &_x-tiny {
            @include media($xlg) {
                width: 96px;
                height: 96px;
            }
            @include media($lg) {
                width: 80px;
                height: 80px;
            }
            width: 70px;
            height: 70px;
            img {
                @include media($xlg) {
                    width: 96px;
                    height: 96px;
                }
                @include media($lg) {
                    width: 80px;
                    height: 80px;
                }
                width: 70px;
                height: 70px;
            }
            .memory-item__number {
                @include media($xlg) {
                    font-size: 52px;
                    line-height: 62px;
                    top: 20%;
                    &_big {
                        left: 20%;
                    }
                }
                font-size: 40px;
                line-height: 43px;
                &_big {
                    left: 15%;
                }
            }
        }
        &_xs-tiny {
            @include media($xlg) {
                width: 86px;
                height: 86px;
            }
            @include media($lg) {
                width: 70px;
                height: 70px;
            }
            width: 60px;
            height: 60px;
            img {
                @include media($xlg) {
                    width: 86px;
                    height: 86px;
                }
                @include media($lg) {
                    width: 70px;
                    height: 70px;
                }
                width: 60px;
                height: 60px;
            }
            .memory-item__number {
                @include media($xlg) {
                    font-size: 42px;
                    line-height: 52px;
                    top: 25%;
                    &_big {
                        left: 25%;
                    }
                }
                font-size: 30px;
                line-height: 33px;
                &_big {
                    left: 22%;
                }
            }
        }
        &__number {
            transform: rotateY(180deg);
            font-weight: 500;
            font-size: 62px;
            line-height: 73px;
            text-align: center;
            color: #ffffff;
            position: absolute;
            top: 20%;
            left: 35%;
            @include media($xlg) {
                top: 30%;
            }
            &_big {
                left: 30%;
            }
            &_hidden {
                visibility: hidden;
            }
        }
    }
    .game-item_hidden {
        visibility: hidden;
    }
    td:empty {
        visibility: hidden;
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
